// Copyright (c) 2016 Deere & Company

import PipDetails from './pip-details';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import searchFilters from './search-filters';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    pipDetails: PipDetails,
    searchFilters
});



// WEBPACK FOOTER //
// ./src/pip/pip-details/reducers/index.js